<template>
    <div class="add-test-block table-bg" v-loading="loading">
        <table>
            <tr>
                <th style="width: 20%">
                    试块组编号
                </th>
                <td style="width: 30%">
                    <el-select v-model="active" @change="changeBlock" placeholder="请选择">
                        <el-option
                            v-for="(item,index) in list"
                            :key="index"
                            :label="item.test_block_group_number"
                            :value="index"
                        >
                        </el-option>
                    </el-select>
                </td>
                <th style="width: 20%">
                    养护条件
                </th>
                <td style="width: 30%">
                    {{ form.maintenance_method_name }}
                </td>
            </tr>
            <tr>
                <th>规格</th>
                <td>
                    {{ form.test_block_specs_name }}
                </td>
                <th>龄期</th>
                <td>
                    {{ form.test_block_age_name }}
                </td>
            </tr>
            <tr>
                <th>制作完成时间</th>
                <td colspan="3">
                    {{ form.producer_completed_time }}
                </td>
            </tr>
        </table>
        <footer>
            <el-button
                type="primary"
                class="save"
                @click="save"
            >
                保存
            </el-button>
            <el-button
                class="Close"
                @click="cancel"
            >
                取消
            </el-button>
        </footer>
    </div>
</template>

<script>
export default {
    name: 'add-test-block',
    props: {
        extr: Object,
    },
    data() {
        return {
            loading: false,
            // 留样id
            tbsid: '',
            list: [],
            active: 0,
            form: {
                tbsid: '',
                sample_number: '',
                test_block_group_number: '',
                test_block_specs: 0,
                test_block_specs_name: '',
                test_block_age: '',
                test_block_age_name: '',
                test_block_type: 0,
                test_block_type_name: '',
                producer_completed_time: '',
                estimate_test_date: '',
                maintenance_method_name: '',
                group_number_index: 0,
            },
        };
    },
    created() {
        this.tbsid = this.extr.tbsid;
        this.getData();
    },
    methods: {
        async getData() {
            this.loading = true;
            this.list = await this.$axios.$get(`/interfaceApi/production/testblock/get_test_block/by_id?tbsid=${this.tbsid}`);
            if (this.list.length > 0) {
                this.form = this.list[0];
            }
            this.loading = false;
        },
        // 选择试块
        changeBlock(index) {
            this.form = this.list[index];
        },
        // 保存
        async save() {
            if (!this.form.test_block_group_number) {
                return;
            }
            try {
                this.loading = true;
                await this.$axios.$post('/interfaceApi/production/testblock/add_test_block_info', this.form);
                this.$message.success('保存成功');
                this.loading = false;
                const frm = window.frames[this.extr.frameId];
                frm.contentWindow.location.reload();
                this.$parent.hide();
            } catch (e) {
                if (e.ErrorCode) {
                    this.$message.error(e.ErrorCode.Message);
                }
                this.loading = false;
            }
        },
        // 取消
        cancel() {
            this.$parent.hide();
        },
    },
};
</script>

<style lang="stylus" scoped>
.add-test-block
    width 100%
    height 100%
    padding 0.2rem
    background #fff
    position relative
    table
        margin-top -1px
        width 100%;
        box-sizing border-box
        border-collapse collapse

        th, td
            font-size 0.16rem
            height 0.38rem
            line-height 0.38rem;
            text-align left
            border: 1px solid #D7D7D7;

        th
            width 2rem
            color #022782
            background: #EDF0F5;
            padding-left 0.26rem
            font-weight normal

        td
            color #333;
            background #fff;
            padding-left 0.15rem

            >>> .el-radio-group
                white-space nowrap

                .el-radio
                    margin-right 0.15rem

            >>> .el-input__inner
                padding-left 0
                border 0

            >>> .is-disabled .el-input__inner
                color #333;
                background-color transparent
            >>> .el-select, .el-input-number, .el-input, .el-checkbox, .el-radio, .el-date-editor
                .el-input__inner
                    font-size 0.16rem
                    height 0.36rem
                    line-height 0.36rem
                .el-input-number
                    line-height 0.36rem
                    .el-input-number__increase, .el-input-number__decrease
                        line-height 0.17rem
                .el-input__icon
                    font-size 0.16rem
                    line-height 0.28rem
                .el-radio__label
                    font-size 0.16rem
                .el-checkbox__label
                    font-size 0.16rem
                    color #333
    footer
        position absolute
        bottom 0.2rem
        width 100%
        height 0.5rem
        display flex
        justify-content center
        align-items center
        button
            width 2rem
            height 0.5rem
            font 0.2rem '微软雅黑'
            margin 0 0.15rem
            border none
            cursor pointer
            display flex
            justify-content center
            align-items center
            &.save
                color #fff
                background #1577D2
            &.Close
                color #1577D2
                background #fff
                border 1px solid #1577D2
</style>
